import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        // You can also log error messages to an error reporting service here
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            return (
                <div className='m-2'>
                    <h2>發生錯誤</h2>
                    {this.state.error && this.state.error.toString()}
                    <br />
                    <br />
                    麻煩將此畫面寄送至 lt.studio.tw@outlook.com
                    <br />
                    🙏🏻🙏🏻 開發者將儘速排除問題！感謝您！
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}